import { Pipe, PipeTransform } from '@angular/core'
import { AuthService } from '@app/services'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { checkImageExists, imageUrl } from '@helpers/common'

@Pipe({
    name: 'authImage',
})
export class AuthImagePipe implements PipeTransform {
    constructor(
        private http: HttpClient,
        private auth: AuthService,
    ) {
    }

    async transform(src: string, type = null): Promise<any> {
        if (!src.startsWith(imageUrl)) {
            src = imageUrl + src
        }
        if (type) {
            src += '?type=' + type
        }
        // check image exists
        return checkImageExists(src).then(async isExists => {
            if (isExists) {
                return src
            } else {
                const token = this.auth.getToken()
                const headers = new HttpHeaders({ Cookie: `token=${ token }` })
                src = src.replace('redirect', 'status')
                const imageResponse: any = await this.http.get(src, { headers, withCredentials: true }).toPromise()
                return new Promise((resolve, reject) => {
                    resolve(imageResponse.url as string)
                })
            }
        })

    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/auth-image.pipe.ts